import { render } from "./Salud.vue?vue&type=template&id=347a42fe&scoped=true"
import script from "./Salud.vue?vue&type=script&lang=js"
export * from "./Salud.vue?vue&type=script&lang=js"

import "./Salud.vue?vue&type=style&index=0&id=347a42fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347a42fe"]])

export default __exports__